"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submitForm = void 0;
const app_1 = require("../../app");
const local_storage_1 = require("../../utils/local-storage");
const submitForm = () => {
    const app = new app_1.App();
    const username = document.getElementById('name').value;
    const alertForm = document.getElementById('form-alert');
    const surname = document.getElementById('surname').value;
    if (username.split('').length > 3 && surname.split('').length > 2) {
        if (username.charAt(0).match(/[A-Z]/) && surname.charAt(0).match(/[A-Z]/)) {
            alertForm.innerText = '';
            (0, local_storage_1.setLogin)(username, surname);
            app.run('main-page');
        }
        else {
            alertForm.innerText = 'error login';
        }
    }
    else if (username.split('').length === 0 || surname.split('').length === 0) {
        alertForm.innerText = 'enter name and surname';
    }
    else {
        alertForm.innerText = 'error login';
    }
};
exports.submitForm = submitForm;
